<template>
  <div>
    <member-form
      v-show="showMemberForm"
      ref="memberForm"
      :embedded-in-model-table="false"
      simplify
      @apply-changes="memberFormApplyChanges()"
      @add-model="memberFormApplyChanges()"
    />
    <div
      class="column"
    >
      <div
        v-if="$register"
        class="col-auto q-mt-md q-mb-lg row justify-center q-gutter-md"
      >
        <q-btn
          v-if="!user"
          outline
          color="primary"
          label="Select User"
          @click="$emit('find-user')"
        />
        <div v-if="user && user.membership && !user.membership.effective && !order.purchasingDayPass">
          <q-btn
            outline
            color="positive"
            label="Activate Membership"
            @click="$emit('modify-membership')"
          />
        </div>
        <div v-if="user && user.membership && user.membership.state === 'pending' && !order.purchasingDayPass">
          <q-btn
            color="negative"
            outline
            label="Fix Pending Membership Charge"
            @click="$emit('fix-pending-membership')"
          />
        </div>
      </div>

      <div
        v-if="user"
        class="q-mt-md q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <q-inner-loading
          v-if="user && user.loading"
          :showing="true"
        />
        <template v-else>
          <div
            class="col-auto text-label text-left text-h6 q-px-sm"
            :class="$q.screen.lt.sm ? 'q-my-sm' : 'q-my-md'"
          >
            Hi {{ user.firstName && user.firstName !== 'Day Pass' ? user.firstName : 'There' }},
            Choose Your {{ membershipTypesAvailable ? 'Member': '' }} Tickets
            <span class="text-negative">{{ activity.hasMinimumAttendance ? ` (Minimum ${activity.minimumAttendance} Tickets Required)` : '' }}</span>
          </div>
          <div
            class="text-h6 text-left bg-grey-4"
            :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
          >
            {{ membershipTypesAvailable ? 'Member': '' }} Tickets
          </div>
          <div
            v-if="activity.loading"
            class="full-width items-center text-center q-list q-list--bordered q-list--separator"
          >
            <q-spinner size="lg" />
          </div>
          <q-list
            v-else-if="userOrderDatas.user"
            bordered
            separator
            style="full-width"
            :class="$register ? undefined : 'bg-white'"
          >
            <q-item
              v-for="userOrderData in $_.concat([userOrderDatas.user], $_.values(userOrderDatas.members))"
              :key="userOrderData.user.id"
              :class="{
                'text-grey': !ticketsAllowed,
                'q-px-sm': $q.screen.lt.sm
              }"
            >
              <q-item-section
                v-if="showMemberImages && $register"
                avatar
              >
                <q-img
                  class="self-center"
                  :src="userOrderData.user.photoUrl"
                  :ratio="1"
                  height="102px"
                  width="102px"
                />
              </q-item-section>
              <q-item-section :style="showMemberImages || $q.screen.lt.lg ? 'min-height: 70px;' : 'height: 62px;'">
                <div :class="$q.screen.lt.sm ? 'column' : 'row q-gutter-x-xs justify-between'">
                  <div
                    class="column items-start justify-center col"
                  >
                    <div
                      class="items-center justify-center"
                    >
                      <span
                        class="ellipsis text-subtitle2"
                        :class="$q.screen.xs ? 'q-mx-xs' : undefined"
                        :style="{
                          'font-size': $q.screen.xs ? '1.1rem': '1.2rem',
                          'max-width': $q.screen.xs ? '60px': '100px',
                          'line-height': $q.screen.xs ? '1.275rem': '1.375rem'
                        }"
                      >
                        {{ userOrderData.user.firstName !== '' ? userOrderData.user.firstName : userOrderData.user.name }}
                      </span>
                      <div
                        class="row justify-center text-uppercase"
                      >
                        <template v-if="$q.screen.gt.xs && (user && user.id) === userOrderData.user.id && (user.dayPassDate || order.purchasingDayPass)">
                          <q-chip
                            class="ellipsis q-ma-none"
                            square
                            dense
                            color="primary"
                            text-color="white"
                            label="Day Pass Holder"
                          />
                        </template>
                        <template v-else-if="$q.screen.gt.xs && userOrderData.user.membership && !userOrderData.user.membershipType.hide && ( $register || userOrderData.user.membership.state === 'active')">
                          <q-chip
                            class="ellipsis q-mx-none"
                            style="max-width: 115px;"
                            square
                            dense
                            :disable="userOrderData.user.type === USER_TYPES.GUEST && !currentCircuit.allowGuests"
                            :color="userOrderData.user.membership.state === 'active' ? 'primary' : null"
                            :text-color="userOrderData.user.membership.state === 'active' ? 'white' : null"
                            :label="(userOrderData.user.membershipType && userOrderData.user.membershipType.name) + (!!userOrderData.user.membershipTier ? (' - ' + userOrderData.user.membershipTier.name) : '')"
                          />
                          <q-icon
                            v-if="userOrderData.user.membership.state !== 'active' && $register"
                            name="cancel"
                            size="sm"
                            color="negative"
                          />
                        </template>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col column  justify-center"
                    :class="$q.screen.lt.lg ? 'items-start' : 'items-center'"
                  >
                    <q-chip
                      v-if="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length <= 1"
                      class="ellipsis q-px-xs"
                      square
                    >
                      {{ userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name }}
                    </q-chip>
                    <q-select
                      v-else
                      class="full-width"
                      :class="$q.screen.xs ? 'q-mt-sm q-mb-md' : undefined"
                      :model-value="userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name"
                      :options="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages)"
                      :disable="configurationConfirmed"
                      dense
                      filled
                      label="View activity ticket options"
                      :hint="$q.screen.gt.xs ? $_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length + ' ticket types available' : undefined"
                      @update:model-value="ticketTypeOrItemPackage => setTicketTypeOrItemPackage(userOrderData, ticketTypeOrItemPackage)"
                    >
                      <template #option="scope">
                        <q-item
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                        >
                          <q-item-section>
                            {{ scope.opt.typeName === 'ItemPackage' ? scope.opt.name : scope.opt.displayName }}
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                </div>
              </q-item-section>
              <q-item-section
                side
                :top="$q.screen.lt.sm"
                :class="{ 'q-mt-sm': $q.screen.lt.sm }"
              >
                <div
                  class="row justify-between text-dark"
                  :style="{ 'min-width': minWidth }"
                >
                  <div
                    class="col column justify-center"
                    :class="$q.screen.lt.lg ? 'items-end q-pr-sm' : 'items-center q-pl-md q-pr-lg'"
                  >
                    <div class="text-body1">
                      <div
                        class="text-weight-bolder text-uppercase"
                        :style="{
                          'font-size': $q.screen.xs ? '1.15rem': '1.2rem',
                          'line-height': $q.screen.xs ? '1.15rem': '1.25rem'
                        }"
                      >
                        From
                        <i18n-n
                          :value="getFromPrice(userOrderData.ticketTypeOrItemPackage)"
                          format="currency"
                          scope="global"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-auto column items-center justify-center"
                    style="min-width: 50px; width: 100%;"
                    :style="{ 'max-width': $q.screen.lt.sm ? '98px' : '108px' }"
                  >
                    <q-btn
                      v-if="!ticketLimitReached || !userTicketTypeOrItemPackageSelected(userOrderData)"
                      class="col-auto row items-center"
                      style="max-width: 108px; min-width: 50px;"
                      :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
                      :label="!ticketsAllowed || (ticketLimitReached && !userTicketTypeOrItemPackageSelected(userOrderData)) ? 'Unavailable' : userTicketTypeOrItemPackageSelected(userOrderData) ? 'Remove' : 'Add'"
                      :square="$register"
                      :rounded="!$register"
                      text-color="dark"
                      :color="ticketsAllowed || (!ticketLimitReached && userTicketTypeOrItemPackageSelected(userOrderData)) && !$register ? 'grey-2' : undefined"
                      :outline="ticketsAllowed || (!ticketLimitReached && userTicketTypeOrItemPackageSelected(userOrderData)) && $register"
                      :flat="!ticketsAllowed || (ticketLimitReached && !userTicketTypeOrItemPackageSelected(userOrderData))"
                      :disable="savingOrder || configurationConfirmed || !ticketsAllowed || (ticketLimitReached && !userTicketTypeOrItemPackageSelected(userOrderData))"
                      @click.stop="userTicketTypeOrItemPackageSelected(userOrderData)
                        ? decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)
                        : increment(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                    >
                      <q-tooltip
                        v-if="ticketLimitReached"
                        :offset="[10, 10]"
                      >
                        Max capacity for activity reached
                      </q-tooltip>
                    </q-btn>
                    <q-item-label
                      v-else
                      class="d-flex justify-around"
                    >
                      <q-btn
                        class="col-auto q-px-xs"
                        icon="fal fa-trash-can"
                        color="grey-2"
                        text-color="dark"
                        round
                        :disable="savingOrder || configurationConfirmed"
                        @click.stop="decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                      />

                      <q-chip
                        color="white"
                        flat
                        square
                        :size="$q.screen.lt.sm ? 'md' : 'lg'"
                      >
                        1
                      </q-chip>
                    </q-item-label>
                  </div>
                </div>
              </q-item-section>
            </q-item>
          </q-list>
          <div
            v-if="$consumer && redeemableVoucherTypes.length > 0 && currentUser"
            class="text-caption text-center q-mt-sm"
          >
            <div
              class="text-bold text-primary"
            >
              {{ currentUser.points }} {{ currentCircuit.rewardsCurrencyName }}
              <q-icon
                style="margin-bottom: 2px;"
                name="info"
              >
                <q-tooltip>
                  <span
                    v-for="(voucherType, index) in redeemableVoucherTypes"
                    :key="voucherType.id"
                  >
                    <br v-if="index !== 0">{{ voucherType.name + ' (' + voucherType.pointsCost + ' ' + currentCircuit.rewardsCurrencyName + ')' }}
                  </span>
                </q-tooltip>
              </q-icon>
            </div>
            <span>Redeem your {{ currentCircuit.rewardsCurrencyName }} during checkout.</span>
          </div>
        </template>
      </div>

      <component
        :is="((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user ? 'q-expansion-item' : 'div'"
        v-if="user || currentSite.allowAnonymousOrders"
        v-model="expand"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          v-if="!(((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user)"
          class="text-h6 text-left bg-grey-4"
          :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
        >
          {{ order.user ? 'Additional Tickets' : 'Tickets' }}
          <div v-if="!$register && activity.loading">
            <q-spinner />
          </div>
        </div>
        <template #header>
          <div
            class="text-h6 text-left"
            :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
          >
            Additional Tickets
          </div>
        </template>
        <div v-if="activity.loading">
          <q-spinner />
        </div>
        <q-list
          bordered
          separator
          style="full-width"
          :class="$register ? undefined : 'bg-white'"
        >
          <div
            v-if="guestTicketTypesOrItemPackages.length === 0"
            class="q-mt-md q-mb-md text-subtitle2 justify-center row"
          >
            No Tickets Available
          </div>
          <q-item
            v-for="ticketTypeOrItemPackage in guestTicketTypesOrItemPackages"
            :key="getKeyForTicketTypeOrItemPackage(ticketTypeOrItemPackage)"
            :class="{ 'q-px-sm': $q.screen.lt.sm }"
          >
            <q-item-section>
              <div class="row">
                <div
                  v-if="isItemPackage(ticketTypeOrItemPackage)"
                  class="col column items-start justify-center"
                >
                  <div
                    class="text-subtitle2"
                    style="font-size: 1rem;"
                  >
                    {{ ticketTypeOrItemPackage.name }}
                  </div>
                  <div
                    class="text-grey-7 text-subtitle"
                    style="font-size: 13px;"
                  >
                    <div
                      v-for="ticketType in ticketTypeOrItemPackage.ticketTypeDescriptions"
                      :key="ticketType.id"
                    >
                      {{ ticketType.description + ' (Activity Ticket)' }}
                    </div>
                    <div
                      v-for="itemVariation in ticketTypeOrItemPackage.itemVariationDescription"
                      :key="itemVariation.id"
                    >
                      {{ itemVariation.name }}
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="col column items-start justify-center"
                >
                  <div
                    class="row items-center justify-center q-gutter-x-xs"
                  >
                    <span
                      class="text-subtitle2"
                      style="font-size: 1rem;"
                    >
                      {{ ticketTypeOrItemPackage.displayName }}
                    </span>
                    <q-icon
                      v-if="ticketTypeOrItemPackage.userClass"
                      style="font-size: 16px; padding-bottom: 2px;"
                      name="info"
                      size="xs"
                      color="grey"
                    >
                      <q-tooltip>
                        {{ ticketTypeOrItemPackage.userClass.description || ticketTypeOrItemPackage.userClass.ageDescription }}
                      </q-tooltip>
                    </q-icon>
                  </div>
                </div>
              </div>
            </q-item-section>

            <q-item-section
              side
              :class="{ 'q-mt-sm': $q.screen.lt.sm }"
            >
              <div
                class="row justify-between text-dark"
                :style="{ 'min-width': minWidth }"
              >
                <div
                  class="col column justify-center"
                  :class="$q.screen.lt.lg ? 'items-end q-pr-sm' : 'items-center q-pl-md q-pr-lg'"
                >
                  <div class="text-body1">
                    <div
                      class="text-weight-bolder text-uppercase"
                      :style="{
                        'font-size': $q.screen.xs ? '1.15rem': '1.2rem',
                        'line-height': $q.screen.xs ? '1.15rem': '1.25rem'
                      }"
                    >
                      From
                      <i18n-n
                        :value="getFromPrice(ticketTypeOrItemPackage)"
                        format="currency"
                        scope="global"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-auto row justify-center items-end"
                  :style="{ 'min-width': $q.screen.lt.lg ? '98px' : '108px' }"
                >
                  <q-btn
                    v-if="!guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage) || activity.maxActivitySpaceCapacity === 1"
                    class="col-auto row items-center"
                    style="max-width: 108px; min-width: 50px;"
                    :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
                    :label="!ticketsAllowed || (ticketLimitReached && !guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) ? 'Unavailable' : 'Add'"
                    :square="$register"
                    :rounded="!$register"
                    text-color="dark"
                    :color="ticketsAllowed || (!ticketLimitReached && guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) && !$register ? 'grey-2' : undefined"
                    :outline="ticketsAllowed || (!ticketLimitReached && guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) && $register"
                    :flat="!ticketsAllowed || (ticketLimitReached && !guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                    :disable="savingOrder || configurationConfirmed || !ticketsAllowed || (ticketLimitReached && !guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                    @click.stop="increment(ticketTypeOrItemPackage)"
                  />
                  <template v-else>
                    <q-btn
                      class="col-auto"
                      :class="{ 'text-grey': savingOrder || configurationConfirmed || !guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage) }"
                      :icon="guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage) === 1 ? 'fal fa-trash-can' : 'fal fa-minus'"
                      dense
                      square
                      outline
                      :disable="savingOrder || configurationConfirmed || !guestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)"
                      @click.stop="decrement(ticketTypeOrItemPackage)"
                    />
                    <div
                      class="col-auto text-h5 q-px-md"
                    >
                      {{ guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage) }}
                    </div>
                    <q-btn
                      class="col-auto"
                      :class="{ 'text-grey': savingOrder || configurationConfirmed || ticketLimitReached }"
                      icon="fal fa-plus"
                      dense
                      square
                      outline
                      :disable="savingOrder || configurationConfirmed || ticketLimitReached"
                      @click.stop="increment(ticketTypeOrItemPackage)"
                    >
                      <q-tooltip
                        v-if="ticketLimitReached"
                        :offset="[10, 10]"
                      >
                        Max capacity for activity reached
                      </q-tooltip>
                    </q-btn>
                  </template>
                </div>
              </div>
            </q-item-section>
          </q-item>
        </q-list>
      </component>

      <div
        v-if="guestTicketTypesOrItemPackages.length > 0 && activity.sessionAdmissionType !== SESSION_ADMISSION_TYPES.SESSION && activity.maxConsecutiveActivityUnits > 1"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          class="text-h6 text-left bg-grey-4"
          :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
        >
          {{ $_.startCase(activity.activityUnitDescriptionPlural) }}
        </div>
        <div
          v-if="activity.loading"
          class="full-width items-center text-center q-list q-list--bordered q-list--separator"
        >
          <q-spinner size="lg" />
        </div>
        <q-list
          bordered
          separator
          style="full-width"
          :class="$register ? undefined : 'bg-white'"
        >
          <q-item>
            <div class="full-width">
              <div class="row">
                <div
                  class="col column items-start justify-center"
                >
                  <div
                    class="row items-center justify-center q-gutter-x-xs"
                  >
                    <span
                      class="text-subtitle2"
                      style="font-size: 1rem;"
                    >
                      {{ $_.startCase(activity.activityUnitDescription) }}
                    </span>
                  </div>
                </div>
                <div
                  class="col-auto row justify-center items-center"
                >
                  <q-btn
                    class="col-auto"
                    :class="{ 'text-grey': savingOrder || configurationConfirmed || activityUnitQuantity <= 1 }"
                    icon="fal fa-minus"
                    dense
                    square
                    outline
                    :disable="savingOrder || configurationConfirmed || activityUnitQuantity <= 1"
                    @click.stop="activityUnitQuantity > 1 && activityUnitQuantity--"
                  />
                  <div
                    class="col-auto text-h5 q-px-md"
                  >
                    {{ activityUnitQuantity }}
                  </div>
                  <q-btn
                    class="col-auto"
                    :class="{ 'text-grey': savingOrder || configurationConfirmed || activityUnitQuantity >= activity.maxConsecutiveActivityUnits }"
                    icon="fal fa-plus"
                    dense
                    square
                    outline
                    :disable="savingOrder || configurationConfirmed || activityUnitQuantity >= activity.maxConsecutiveActivityUnits"
                    @click.stop="activityUnitQuantity < activity.maxConsecutiveActivityUnits && activityUnitQuantity++"
                  />
                </div>
              </div>
            </div>
          </q-item>
        </q-list>
      </div>

      <div
        v-if="showDateSelection"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          class="text-h6 text-left bg-grey-4"
          :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
        >
          Date
        </div>
        <date-toggle
          ref="dateToggle"
          :activity-id="activity.id"
          :disabled="configurationConfirmed"
          @select-date="selectedDate => selectedActivitySessionDate = selectedDate.replace(/-/g, '/')"
        />
      </div>

      <div
        v-if="showTimeSelection"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          class="text-h6 text-left bg-grey-4"
          :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
        >
          Available Times
        </div>
        <q-select
          v-model="selectedActivitySessionEntryTime"
          class="col-4"
          label="Select a Time"
          :options="availableEntryTimes"
          :loading="activitySessions.loading"
          :disable="numSelectedTickets === 0 || !meetsMinimumAttendanceRequirements || activitySessions.loading || configurationConfirmed"
          map-options
          emit-value
          clearable
        />
        <q-tooltip v-if="numSelectedTickets === 0 || !meetsMinimumAttendanceRequirements">
          {{ numSelectedTickets === 0 ? 'Select tickets to view available times' : `You must select at least ${activity.minimumAttendance} tickets` }}
        </q-tooltip>
      </div>

      <div
        v-if="showTimeSelection"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          class="row justify-between"
        >
          <q-btn
            size="lg"
            color="secondary"
            :disable="disableEdit"
            :style="{ opacity: disableEdit ? 0.5 : 1 }"
            outline
            @click="edit"
          >
            Edit
          </q-btn>
          <q-btn
            size="lg"
            color="primary"
            :disable="disableConfirm"
            :loading="savingOrder"
            :style="{ opacity: disableConfirm ? 0.5 : 1 }"
            @click="confirm"
          >
            Confirm
            <q-tooltip v-if="disableConfirm && !configurationConfirmed">
              {{ numSelectedTickets === 0
                ? 'Select tickets to continue'
                : meetsMinimumAttendanceRequirements ? 'Select a date and time to continue' : `You must select at least ${activity.minimumAttendance} tickets` }}
            </q-tooltip>
          </q-btn>
        </div>
      </div>

      <div
        v-if="showTimeSelection"
        class="q-mb-md"
        style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
      >
        <div
          v-if="$consumer && currentSite.hasBookingFees && !!currentSite.bookingFeeText"
          class="text-responsive-grey-7 text-center text-subtitle q-my-sm"
        >
          {{ currentSite.bookingFeeText }}
        </div>
      </div>

      <add-friends
        v-if="currentCircuit.allowFriends && user"
        :user="user"
      />
    </div>
  </div>
</template>

<script>
import { date } from 'quasar'
import Activity, { SESSION_ADMISSION_TYPES } from 'src/models/activity/Activity'
import ActivitySession from 'src/models/activity-session/ActivitySession'
import { IsoDateTime } from 'src/models/Model'
import { getTicketTypesFromItemPackage } from 'src/models/package/ItemPackage'
import { USER_TYPES } from 'src/models/user/User'
import AddFriends from 'src/modules/consumer/components/AddFriends'
import DateToggle from 'src/modules/register/components/DateToggle'
import MemberForm from 'src/modules/register/membership/MemberForm'

const { addToDate, formatDate } = date

export default {
  name: 'ActivityComposer',
  components: { AddFriends, DateToggle, MemberForm },
  inject: ['order'],
  props: {
    activity: {
      type: Activity,
      required: true
    },
    activitySession: {
      type: ActivitySession,
      default: null
    }
  },
  context: ['currentUser'],
  configuration: ['currentSite', 'currentCircuit', 'membershipTypes', 'voucherTypes'],
  emits: ['find-user', 'modify-membership', 'fix-pending-membership', 'configuration-confirmed'],
  data () {
    return {
      /**
       * {
        user: {
          user: {
            ...
          },
          ticketTypeOrItemPackage: {
            ...
          },
          memberTicketTypes: [],
          memberItemPackages: []
        },
        members: {
          [userId]: {
            user: {
              ...
            },
            ticketTypeOrItemPackage: {
              ...
            },
            memberTicketTypes: [],
            memberItemPackages: []
          }
        }
      }
       */
      userOrderDatas: {},
      ticketTypeQuantities: {
        member: {},
        guest: {}
      },
      itemPackageQuantities: {
        member: {},
        guest: {}
      },
      activityUnitQuantity: 1,
      selectedActivitySessionDate: null,
      selectedActivitySessionEntryTime: null,
      savingOrder: false,
      expand: false,
      showMemberForm: false
    }
  },
  models: {
    datesWithActivities: {
      variables () {
        return {
          activity_id: this.activity.id,
          skip: !!this.activitySession
        }
      },
      immediate: true
    },
    activitySessions: {
      activity: true,
      activitySpace: true,
      availableEntries: true,
      priceCard: true,
      variables () {
        return {
          activitySessionId: this.activitySession?.id,
          activityId: this.activity.id,
          date: this.activitySessionDate,
          ticketTypeQuantities: this.combinedTicketTypeQuantities,
          activityUnitQuantity: this.activityUnitQuantity,
          orderId: this.order.isRemote ? this.order.id : null,
          limit: 0,
          skip: this.numSelectedTickets === 0 || !this.meetsMinimumAttendanceRequirements || !this.activitySessionDate
        }
      },
      force: true
    }
  },
  computed: {
    minWidth () {
      if (this.$kiosk) return '300px'
      if (this.$q.screen.xs) return '170px'
      if (this.$q.screen.lt.lg) return '200px'
      return '300px'
    },
    membershipTypesAvailable () {
      return !!_.find(this.membershipTypes.data, membershipType => {
        return !membershipType.default && !membershipType.hide && membershipType.availableOnline
      })
    },
    redeemableVoucherTypes () {
      return _.sortBy(_.filter(this.voucherTypes.data, voucherType => {
        return voucherType.isReward && voucherType.pointsCost <= this.currentUser.points
      }), 'pointsCost')
    },
    combinedTicketTypeQuantities () {
      const combinedTicketTypeQuantities = {
        ...this.ticketTypeQuantities.guest
      }

      _(this.ticketTypeQuantities.member).values().each(memberTicketTypeQuantities => {
        _(memberTicketTypeQuantities).entries().each(([ticketTypeId, quantity]) => {
          combinedTicketTypeQuantities[ticketTypeId] = (combinedTicketTypeQuantities[ticketTypeId] || 0) + quantity
        })
      })

      _(this.itemPackageQuantities.guest).entries().each(([itemPackageId, quantity]) => {
        const itemPackage = _.find(this.allItemPackages, { id: +itemPackageId })

        if (!itemPackage) return

        const ticketTypeIds = _.map(getTicketTypesFromItemPackage(itemPackage), 'id')

        _(ticketTypeIds).each(ticketTypeId => {
          combinedTicketTypeQuantities[ticketTypeId] = (combinedTicketTypeQuantities[ticketTypeId] || 0) + quantity
        })
      })

      _(this.itemPackageQuantities.member).values().each(memberItemPackageQuantities => {
        _(memberItemPackageQuantities).entries().each(([itemPackageId, quantity]) => {
          const itemPackage = _.find(this.allItemPackages, { id: +itemPackageId })

          if (!itemPackage) return

          const ticketTypeIds = _.map(getTicketTypesFromItemPackage(itemPackage), 'id')

          _(ticketTypeIds).each(ticketTypeId => {
            combinedTicketTypeQuantities[ticketTypeId] = (combinedTicketTypeQuantities[ticketTypeId] || 0) + quantity
          })
        })
      })

      return combinedTicketTypeQuantities
    },
    user () {
      return this.order.user
    },
    ticketsAllowed () {
      return !this.currentSite.membershipRequired || (this.user?.membership?.effective && this.user?.unlimitedMembershipTicketVoucherTypes.length > 0)
    },
    showMemberImages () {
      return this.$register && this.user && _(this.userOrderDatas.member).values().every(({ user }) => user.hasPhoto)
    },
    showDateSelection () {
      return !this.activitySession
    },
    showTimeSelection () {
      return !this.activitySession || this.activity.sessionAdmissionType !== SESSION_ADMISSION_TYPES.SESSION
    },
    activitySessionDate () {
      let activitySessionDate

      if (!this.showDateSelection) {
        activitySessionDate = formatDate(this.activitySession.siteStartTime, 'YYYY/MM/DD')
      } else {
        activitySessionDate = this.selectedActivitySessionDate
      }

      return activitySessionDate
    },
    activitySessionEntryTime () {
      let activitySessionEntryTime

      if (!this.showTimeSelection) {
        activitySessionEntryTime = this.activitySession.startTime
      } else {
        activitySessionEntryTime = this.selectedActivitySessionEntryTime
      }

      return activitySessionEntryTime
    },
    numSelectedTickets () {
      return _(this.combinedTicketTypeQuantities).values().sum()
    },
    meetsMinimumAttendanceRequirements () {
      return this.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.SESSION ||
        !this.activity.isExclusive ||
        !this.activity.hasMinimumAttendance ||
        this.numSelectedTickets >= this.activity.minimumAttendance
    },
    ticketLimitReached () {
      return this.numSelectedTickets >= this.activity.maxActivitySpaceCapacity
    },
    disableEdit () {
      return !this.configurationConfirmed
    },
    disableConfirm () {
      return this.configurationConfirmed ||
        this.numSelectedTickets === 0 ||
        !this.meetsMinimumAttendanceRequirements ||
        !this.activitySessionDate ||
        !this.activitySessionEntryTime
    },
    guestTicketTypes () {
      return this.activity.guestTicketTypes || []
    },
    guestItemPackages () {
      return this.activity.guestItemPackages || []
    },
    guestTicketTypesOrItemPackages () {
      return _.concat(this.guestTicketTypes, this.guestItemPackages)
    },
    allItemPackages () {
      return this.activity.allItemPackages
    },
    availableEntryDates () {
      if (this.activitySession) {
        return [formatDate(this.activitySession.siteStartTime, 'YYYY/MM/DD')]
      } else {
        return this.datesWithActivities.value?.map(date => date.replace(/-/g, '/')) || []
      }
    },
    availableEntries () {
      const entriesByDateAndSession = {}

      _(this.activitySessions.data).each(activitySession => {
        const date = formatDate(activitySession.siteStartTime, 'YYYY/MM/DD')
        entriesByDateAndSession[date] ||= {}
        entriesByDateAndSession[date][activitySession.id] = activitySession.availableEntries
      })

      return entriesByDateAndSession
    },
    availableEntryTimes () {
      if (!this.activitySessionDate) return []

      return _(this.availableEntries[this.activitySessionDate])
        .values()
        .flatten()
        .uniqBy(date => date.i18n('shortTime'))
        .sortBy(date => date.getTime())
        .map(time => {
          const dateTime = new IsoDateTime(time)
          return {
            label: this.$d(dateTime.inTimeZone(this.currentSite.timeZone), 'shortTime'),
            value: dateTime
          }
        })
        .value()
    },
    activityTicketOrderItems () {
      /**
       * Select the order items related to this activity configuration. Either a
       * specific session (POS) or everything for the activity (Consumer).
       */
      return _.filter(this.order.activityTicketOrderItems, orderItem => {
        if (this.activitySession) {
          return orderItem.isDraft && orderItem.activityTicket.activitySession.id === this.activitySession.id
        } else {
          return orderItem.isDraft && orderItem.activityTicket.activity.id === this.activity.id
        }
      })
    },
    activityConfigurationOrderItems () {
      const activityTicketItemPackageIds = _(this.activityTicketOrderItems).map('itemPackageId').compact().uniq().value()

      return _.filter(this.order.draftOrderItems, orderItem => {
        if (orderItem.activityTicket) {
          return _(this.activityTicketOrderItems).map('id').includes(orderItem.id)
        } else if (orderItem.itemPackage) {
          return _.includes(activityTicketItemPackageIds, orderItem.itemPackage.id)
        } else {
          return false
        }
      })
    },
    configurationConfirmed () {
      return !!this.activityTicketOrderItems.length
    }
  },
  watch: {
    'user.loading' () {
      if (this.user?.loading === false) {
        this.computeUserOrderDatas()
      }
    },
    'activity.loading' () {
      if (this.activity?.loading === false) {
        this.computeUserOrderDatas()
      }
    },
    availableEntryDates () {
      if (!this.activitySessions.loading && this.activitySessionDate && !_.includes(this.availableEntryDates, this.activitySessionDate)) {
        this.selectedActivitySessionDate = null
        this.selectedActivitySessionEntryTime = null
      }
    },
    availableEntryTimes () {
      if (this.activitySessions.loading || !this.selectedActivitySessionEntryTime) return

      const availableEntryTimeStrings = _(this.availableEntryTimes).map('value').map(time => time.toString()).value()
      const activitySessionEntryTimeString = this.selectedActivitySessionEntryTime.toString()

      if (!_.includes(availableEntryTimeStrings, activitySessionEntryTimeString)) {
        this.selectedActivitySessionEntryTime = null
      }
    },
    selectedActivitySessionDate () {
      const selectedActivitySessionDateFormatted = this.selectedActivitySessionDate?.replace(/\//g, '-')
      if (selectedActivitySessionDateFormatted && this.$refs.dateToggle?.date && selectedActivitySessionDateFormatted !== this.$refs.dateToggle?.date) {
        /**
         * Set the date toggle date when we restore the configuration from destroyed order items.
         */
        this.$refs.dateToggle.date = selectedActivitySessionDateFormatted
      }
    },
    configurationConfirmed: {
      handler: function () {
        this.$emit('configuration-confirmed', this.configurationConfirmed)
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, { SESSION_ADMISSION_TYPES, USER_TYPES })
  },
  async mounted () {
    if (this.configurationConfirmed) {
      this.restoreActivityConfiguration()
    }

    this.order.currentActivity = this.activity

    if (!this.$register && !this.$kiosk) {
      if (this.currentUser) {
        const orderUser = this.order.setRelated('user', { id: this.currentUser.id })
        await orderUser.fetch(true)
      }
    }

    this.computeUserOrderDatas()
  },
  methods: {
    getFromPrice (ticketTypeOrItemPackage) {
      const fromPriceKey = ticketTypeOrItemPackage.typeName === 'ItemPackage' ? 'item_packages' : 'ticket_types'
      return this.activity.fromPrices?.[fromPriceKey]?.[ticketTypeOrItemPackage.id]
    },
    memberFormApplyChanges () {
      this.editingUser.save()
      this.showMemberForm = false
    },
    setTicketTypeOrItemPackage (userOrderData, ticketTypeOrItemPackage) {
      if (this.userTicketTypeOrItemPackageSelected(userOrderData)) {
        this.decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)
      }

      userOrderData.ticketTypeOrItemPackage = ticketTypeOrItemPackage
    },
    toggleExpand () {
      this.expand = !this.expand
    },
    isItemPackage (object) {
      if (typeof object === 'object') {
        return object.constructor.name === 'ItemPackage'
      } else {
        return false
      }
    },
    getKeyForTicketTypeOrItemPackage (ticketTypeOrItemPackage) {
      return `${ticketTypeOrItemPackage.constructor.name}-${ticketTypeOrItemPackage.id}`
    },
    computeUserOrderDatas () {
      if (this.user?.loading === false && this.activity?.loading === false) {
        this.userOrderDatas = this.order.getTicketTypesAndItemPackagesForUserAndPurchasableMembers(this.user, this.activity, this.ticketTypeQuantities, this.itemPackageQuantities)
      } else {
        this.userOrderDatas = {}
      }
    },
    userTicketTypeOrItemPackageSelected (userOrderData) {
      const collection = userOrderData.ticketTypeOrItemPackage.typeName === 'ItemPackage' ? this.itemPackageQuantities : this.ticketTypeQuantities
      return !!collection.member[userOrderData.user.id]?.[userOrderData.ticketTypeOrItemPackage.id]
    },
    guestTicketTypeOrItemPackageSelected (ticketTypeOrItemPackage) {
      return !!this.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage)
    },
    guestTicketTypeOrItemPackageQuantity (ticketTypeOrItemPackage) {
      const collection = ticketTypeOrItemPackage.typeName === 'ItemPackage' ? this.itemPackageQuantities : this.ticketTypeQuantities
      return collection.guest[ticketTypeOrItemPackage.id]
    },
    async confirm () {
      await this.createOrderItems()
    },
    async edit () {
      await this.destroyOrderItems()

      if (this.selectedActivitySessionEntryTime) {
        /**
         * Refetch the activity sessions so we can be sure the selected entry
         * time is still available.
         */
        this.activitySessions.fetch(true)
      }
    },
    getUserFromUserOrderDatas (userId) {
      return _.find(
        _.concat(
          [this.userOrderDatas.user],
          _.values(this.userOrderDatas.members)
        ),
        userOrderData => userOrderData.user.id === +userId
      )?.user
    },
    async createOrderItems () {
      /**
       * Make sure we're able to resolve an activity session from the
       * configuration (or from the activity session we're starting from)
       */
      const activitySession = _.find(this.activitySessions.data, activitySession => {
        if (this.activitySession) {
          return activitySession.id === this.activitySession.id
        } else {
          return formatDate(activitySession.siteStartTime, 'YYYY/MM/DD') === this.activitySessionDate &&
            _(activitySession.availableEntries).map(entry => entry.toString()).includes(this.selectedActivitySessionEntryTime.toString())
        }
      })

      if (!activitySession) {
        return
      }

      this.savingOrder = true
      const activityCompositionId = new Date().getTime()

      /**
       * Compute the exit time based on the session admission type.
       */
      let exitTime
      if (this.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.ACTIVITY_UNIT_DYNAMIC) {
        exitTime = addToDate(this.activitySessionEntryTime, {
          minutes: this.activity.activityUnitDurationMinutes * this.activityUnitQuantity * this.numSelectedTickets
        })
      } else if (this.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.ACTIVITY_UNIT_FIXED) {
        exitTime = addToDate(this.activitySessionEntryTime, {
          minutes: this.activity.activityUnitDurationMinutes * this.activityUnitQuantity
        })
      } else {
        exitTime = activitySession.endTime
      }

      /**
       * Create the member order items for each ticket type.
       */
      _(this.ticketTypeQuantities.member).entries().each(([userId, ticketTypeIdsAndQuantities]) => {
        const user = this.getUserFromUserOrderDatas(userId)

        _(ticketTypeIdsAndQuantities).entries().each(([ticketTypeId, quantity]) => {
          for (let i = 0; i < quantity; i++) {
            this.order.createActivityTicketOrderItemAndAddToOrder(
              activityCompositionId,
              activitySession,
              ticketTypeId,
              this.activityUnitQuantity,
              this.activitySessionEntryTime,
              exitTime,
              user
            )
          }
        })
      })

      /**
       * Create the guest order items for each ticket type.
       */
      _(this.ticketTypeQuantities.guest).entries().each(([ticketTypeId, quantity]) => {
        for (let i = 0; i < quantity; i++) {
          this.order.createActivityTicketOrderItemAndAddToOrder(
            activityCompositionId,
            activitySession,
            ticketTypeId,
            this.activityUnitQuantity,
            this.activitySessionEntryTime,
            exitTime
          )
        }
      })

      /**
       * Create the member order items for each item package.
       */
      _(this.itemPackageQuantities.member).entries().each(([userId, itemPackageIdsAndQuantities]) => {
        const user = this.getUserFromUserOrderDatas(userId)

        _(itemPackageIdsAndQuantities).entries().each(([itemPackageId, quantity]) => {
          const itemPackage = _.find(this.allItemPackages, { id: +itemPackageId })

          if (itemPackage) {
            for (let i = 0; i < quantity; i++) {
              this.order.createItemPackageOrderItemsForActivityAndAddToOrder(
                activityCompositionId,
                activitySession,
                itemPackage,
                this.activityUnitQuantity,
                this.activitySessionEntryTime,
                exitTime,
                user
              )
            }
          }
        })
      })

      /**
       * Create the guest order items for each item package.
       */
      _(this.itemPackageQuantities.guest).entries().each(([itemPackageId, quantity]) => {
        const itemPackage = _.find(this.allItemPackages, { id: +itemPackageId })

        if (itemPackage) {
          for (let i = 0; i < quantity; i++) {
            this.order.createItemPackageOrderItemsForActivityAndAddToOrder(
              activityCompositionId,
              activitySession,
              itemPackage,
              this.activityUnitQuantity,
              this.activitySessionEntryTime,
              exitTime
            )
          }
        }
      })

      await this.order.save
      this.savingOrder = false
    },
    async destroyOrderItems () {
      if (_.isEmpty(this.activityConfigurationOrderItems)) return

      this.savingOrder = true

      _.each(this.activityConfigurationOrderItems, orderItem => {
        /**
         * Destroy the order items so that the activity can be reconfigured.
         * The available entries may change if the ticket type quantities or
         * activity unit quantity changes, and the exit time will need to be
         * recomputed based on the session admission type.
         */
        this.order.orderItems.remove(orderItem)
      })

      await this.order.save
      this.savingOrder = false
    },
    async restoreActivityConfiguration () {
      const itemPackageQuantities = {
        member: {},
        guest: {}
      }

      const ticketTypeQuantities = {
        member: {},
        guest: {}
      }

      /**
       * Restore item package configuration from the activity ticket order items
       * that belong to item packages.
       */
      _(this.activityTicketOrderItems)
        .filter(orderItem => !!orderItem.itemPackageId)
        .groupBy('itemPackageId')
        .each((activityTicketOrderItemsForItemPackage, itemPackageId) => {
          const itemPackage = _.find(this.allItemPackages, { id: +itemPackageId })

          if (itemPackage) {
            _(activityTicketOrderItemsForItemPackage).groupBy('activityTicket.user.id').each((activityTicketOrderItemsForUser, userId) => {
              const [ticketTypeId, ticketTypeQuantity] = _(activityTicketOrderItemsForUser).countBy('activityTicket.ticketTypeId').entries().value()[0]
              const itemPackageTicketTypeQuantity = _(getTicketTypesFromItemPackage(itemPackage))
                .filter(ticketType => ticketType.id === +ticketTypeId).value().length
              const itemPackageQuantity = ticketTypeQuantity / itemPackageTicketTypeQuantity

              console.log({ userId }, { ticketTypeQuantity }, { itemPackageTicketTypeQuantity })
              if (userId === 'undefined') {
                itemPackageQuantities.guest[itemPackageId] = itemPackageQuantity
              } else {
                itemPackageQuantities.member[userId] ||= {}
                itemPackageQuantities.member[userId][itemPackageId] = itemPackageQuantity
              }
            })
          }
        })

      this.itemPackageQuantities = itemPackageQuantities

      /**
       * Restore the ticket type configuration from the activity ticket order
       * items that do NOT belong to item packages.
       */
      _(this.activityTicketOrderItems)
        .filter(orderItem => !orderItem.itemPackageId)
        .each(orderItem => {
          if (orderItem.activityTicket.user) {
            ticketTypeQuantities.member[orderItem.activityTicket.user.id] ||= {}
            ticketTypeQuantities.member[orderItem.activityTicket.user.id][orderItem.activityTicket.ticketTypeId] ||= 0
            ticketTypeQuantities.member[orderItem.activityTicket.user.id][orderItem.activityTicket.ticketTypeId]++
          } else {
            ticketTypeQuantities.guest[orderItem.activityTicket.ticketTypeId] ||= 0
            ticketTypeQuantities.guest[orderItem.activityTicket.ticketTypeId]++
          }
        })

      this.ticketTypeQuantities = ticketTypeQuantities

      /**
       * Restore the activity unit configuration.
       */
      const firstActivityTicket = this.activityTicketOrderItems[0].activityTicket
      this.activityUnitQuantity = firstActivityTicket.activityUnitQuantity

      if (!this.activitySession) {
        /**
         * We're not starting from an activity session, so we need to restore
         * the selected date and entry time if they're still available.
         */
        await this.datesWithActivities.ensureLoaded()

        const activitySessionDate = formatDate(firstActivityTicket.activitySession.siteStartTime, 'YYYY/MM/DD')

        if (_.includes(this.availableEntryDates, activitySessionDate)) {
          /**
           * Only restore the date if it's still available.
           */
          this.selectedActivitySessionDate = activitySessionDate

          await this.$nextTick()
          await this.activitySessions.ensureLoaded()

          const activitySessionEntryTime = firstActivityTicket.entryTime
          const availableEntryTimeStrings = _(this.availableEntryTimes).map('value').map(time => time.toString()).value()
          const activitySessionEntryTimeString = activitySessionEntryTime.toString()

          if (_.includes(availableEntryTimeStrings, activitySessionEntryTimeString)) {
            /**
             * Only restore the entry time if it's still available.
             */
            this.selectedActivitySessionEntryTime = activitySessionEntryTime
          }
        }
      } else if (this.activity.sessionAdmissionType !== SESSION_ADMISSION_TYPES.SESSION) {
        /**
         * We're starting from an activity session, but the admission type is
         * dynamic, so we still need to restore the selected entry time if
         * it's still available. We reload the activity session for up to date
         * entry times.
         */
        await this.activitySessions.ensureLoaded()

        const activitySessionEntryTime = firstActivityTicket.entryTime
        const availableEntryTimeStrings = _(this.availableEntryTimes).map('value').map(time => time.toString()).value()
        const activitySessionEntryTimeString = activitySessionEntryTime.toString()

        if (_.includes(availableEntryTimeStrings, activitySessionEntryTimeString)) {
          /**
           * Only restore the entry time if it's still available.
           */
          this.selectedActivitySessionEntryTime = activitySessionEntryTime
        }
      }
    },
    increment (ticketTypeOrItemPackage, user = null) {
      if (user?.type === USER_TYPES.GUEST && !this.currentCircuit.allowGuests) {
        this.editingUser = user
        this.$refs.memberForm.show(user)
        this.showMemberForm = true
        return
      }

      const collection = ticketTypeOrItemPackage.typeName === 'ItemPackage' ? this.itemPackageQuantities : this.ticketTypeQuantities
      const ticketTypeOrItemPackageId = ticketTypeOrItemPackage.id

      if (user) {
        /**
         * The user can only have one ticket type per configuration, so the quantity is always 1
         */
        collection.member = {
          ...collection.member,
          [user.id]: {
            [ticketTypeOrItemPackageId]: 1
          }
        }
      } else {
        collection.guest = {
          ...collection.guest,
          [ticketTypeOrItemPackageId]: (collection.guest[ticketTypeOrItemPackageId] || 0) + 1
        }
      }
    },
    decrement (ticketTypeOrItemPackage, user = null) {
      const collection = ticketTypeOrItemPackage.typeName === 'ItemPackage' ? this.itemPackageQuantities : this.ticketTypeQuantities
      const ticketTypeOrItemPackageId = ticketTypeOrItemPackage.id

      if (user) {
        collection.member = {
          ...collection.member,
          [user.id]: {
            [ticketTypeOrItemPackageId]: 0
          }
        }
      } else {
        collection.guest = {
          ...collection.guest,
          [ticketTypeOrItemPackageId]: collection.guest[ticketTypeOrItemPackageId] - 1
        }
      }
    }
  }
}
</script>
